/* eslint-disable @typescript-eslint/no-explicit-any */
import SocialVideoChannels from '@apps/components/SocialVideoChannels';
import { ISocialVideo, ISocialVideoChannel } from '@apps/types';
import useTranslation from 'next-translate/useTranslation';

type SocialVideoScreenProps = {
  data?: {
    channels: ISocialVideoChannel[];
    videos: {
      tiktok: ISocialVideo[];
      youtube: ISocialVideo[];
    };
  };
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SocialVideoScreen: React.FC<SocialVideoScreenProps | any> = (
  props
) => {
  const { data, setChannelType, loading } = props;

  // ======================= HOOKS
  const { t } = useTranslation('common');

  // ======================= VIEWS
  return (
    <div>
      <h1>{t('socialVideo')}</h1>
      <SocialVideoChannels
        data={data}
        setChannelType={setChannelType}
        loading={loading}
      />
    </div>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SocialVideoScreen;
